<template>
	<div class="order-verify-container">
		<!-- 绿色横幅 -->
		<div class="searchbanner">
			<div class="banner-content">
				<div class="banner-left">
					<h1 class="banner-title">正版授权查询验证</h1>
					<p class="banner-subtitle">输入报告编号，一键查询企业正版授权信息</p>
				</div>
			</div>
		</div>

		<!-- 搜索区域 -->
		<div class="search-section">
			<el-card shadow="never" class="search-card">
				<el-form :inline="true" :model="searchForm" class="search-form" label-position="top">
					<el-form-item label="报告编号查询" label-position="top">
						<div class="search-input-wrap">
							<el-input ref="searchInput" v-model="searchForm.keyword" placeholder="请输入报告编号" clearable prefix-icon="el-icon-search" @keyup.enter.native="handleSearch" class="search-input">
							</el-input>
							<el-button type="primary" icon="el-icon-search" @click="handleSearch" :loading="loading" :disabled="hasSearched" round>查询</el-button>
							<el-button icon="el-icon-refresh" @click="handleReset" :disabled="loading" style="margin-left: 0" round>重置</el-button>
						</div>
					</el-form-item>
				</el-form>
			</el-card>
		</div>

		<!-- 查询结果区域 -->
		<div class="result-section" v-if="hasSearched && !loading">
			<el-card shadow="never" class="result-card">
				<!-- 报告标题 -->
				<div class="report-title-wrap">
					<h1 class="report-main-title">特规通正版资料说明</h1>
				</div>

				<!-- 企业信息行 -->
				<div class="report-info-bar" v-if="reportInfo.companyName">
					<div class="info-left">
						<span class="info-label">企业名称：</span>
						<span class="info-value">{{ reportInfo.companyName }}</span>
					</div>
					<div class="info-left">
						<span class="info-label">报告编号：</span>
						<span class="info-value">{{ reportInfo.reportNo }}</span>
					</div>
					<div class="info-left">
						<span class="info-label">生成时间：</span>
						<span class="info-value">{{ reportInfo.generateTime }}</span>
					</div>
					<div class="info-right">
						<span class="info-label">文件总数：</span>
						<span class="info-count">{{ tableData.length }}</span>
					</div>
				</div>

				<!-- 第一节：企业已购电子标准清单 -->
				<div class="section-block" v-if="tableData.length > 0">
					<div v-if="!isBV">
						<h3 class="section-title">一、企业已购电子标准清单</h3>
						<div class="verify-table-wrap">
							<table class="verify-table">
								<thead>
									<tr>
										<th class="col-seq">序号</th>
										<th class="col-code">文件编号</th>
										<th class="col-name">文件名称</th>
										<th class="col-type">文件类型</th>
										<th class="col-status">实施状态</th>
										<th class="col-name">商品名称</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, idx) in tableData" :key="idx" :class="{ 'row-even': idx % 2 === 1 }">
										<td class="col-seq">{{ item.id || idx + 1 }}</td>
										<td class="col-code">{{ item.standardCode || '-' }}</td>
										<td class="col-name">{{ item.standardName || '-' }}</td>
										<td class="col-type">{{ item.standardTypeName || '-' }}</td>
										<td class="col-status">{{ item.lifeName || '-' }}</td>
										<td class="col-name">{{ item.skuName || '-' }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div v-else>
						<h3 class="section-title">一、企业正版法规标准清单</h3>
						<div class="verify-table-wrap">
							<table class="verify-table">
								<thead>
									<tr>
										<th class="col-seq">序号</th>
										<th class="col-code">文件编号</th>
										<th class="col-name">文件名称</th>
										<th class="col-type">文件类型</th>
										<th class="col-status">实施状态</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, idx) in tableData" :key="idx" :class="{ 'row-even': idx % 2 === 1 }">
										<td class="col-seq">{{ item.id || idx + 1 }}</td>
										<td class="col-code">{{ item.standardCode || '-' }}</td>
										<td class="col-name">{{ item.standardName || '-' }}</td>
										<td class="col-type">{{ item.standardTypeName || '-' }}</td>
										<td class="col-status">{{ item.lifeName || '-' }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<!-- 第二节：企业已购电子标准正版使用说明 -->
				<div class="section-block" v-if="tableData.length > 0">
					<div class="buy" v-if="!isBV">
						<h3 class="section-title">二、企业已购电子标准正版使用说明</h3>

						<div class="usage-statement">
							<p class="usage-paragraph">
								兹说明，<strong>{{ reportInfo.companyName }}</strong>
								为"特规通"平台（<a>https://co.teguitong.com</a>）注册企业用户。该企业通过特规通平台购买的电子版法规标准资料，均由特规通通过出版社官方授权渠道或合法授权合作渠道提供，资料来源合法合规，版权权属清晰，购买记录真实可查。
							</p>
							<p class="usage-paragraph">
								本说明所附《企业已购电子标准清单》为该企业截至
								<strong>{{ reportInfo.generateTime }}</strong>
								在特规通平台已购买电子版法规标准资料的系统记录，可作为企业已购买电子法规标准资料的说明依据；上述电子版法规标准资料已根据平台版权保护规则添加企业专属水印，并进行密钥保护。企业用户可在特规通平台授权范围内进行在线查阅，也可下载带有正版水印和加密保护的
								PDF 文件用于本企业内部使用。
							</p>
							<p class="usage-paragraph">
								本清单所列电子版法规标准资料，仅限
								<strong>{{ reportInfo.companyName }}</strong>
								用户正常生产经营、技术研究、质量管理、人员培训、许可评审、合规审核、监督检查、认证申请等内部业务活动。未经授权，不得将相关电子文件复制、传输、转售、转授、公开发布或提供给无关第三方使用。本说明及所附清单可用于企业开展合规认证、许可评审、质量保证体系审核、监督检查、内部资料管理及相关合规申请时，对电子版法规标准资料正版来源、购买记录和授权使用情况进行说明。
							</p>
						</div>
					</div>
					<div class="join" v-if="isBV">
						<h3 class="section-title">二、企业正版资料使用授权说明</h3>

						<div class="usage-statement">
							<p class="usage-paragraph">
								兹说明，
								"特规通"平台（<a>https://co.teguitong.com</a>)所收录并向企业用户提供的法规、标准、专业图书等资料文件,均来源于正规出版发行渠道、授权合作机构或权威信息来源,资料来源合法合规、版权权属清晰、内容可追溯核验。
								。
							</p>
							<p class="usage-paragraph">
								<strong>{{ reportInfo.companyName }}</strong
								>为“特规通”平台注册企业用户,已按照平台服务规则取得本清单所列资料文件的使用权限,可在授权范围内进行查阅、检索、 阅读及 AI 辅助使用。
							</p>
							<p class="usage-paragraph">
								本清单内资料文件仅限该企业用于正常生产经营、技术研发、质量管理、人员培训、许可评审、合规审核等内部业务活动,不得超出授权范围 复制、传播、转售、转授权或向无关第三方提供。
							</p>
							<p class="usage-paragraph">本说明可作为企业开展合规认证、许可评审、监督检查、体系审核及内部资料管理时,对相关法规标准及专业图书资料来源合法性、正版合规 性和使用权限的说明依据。</p>
						</div>
					</div>
				</div>

				<!-- 无数据 -->
				<div class="section-block" v-if="tableData.length === 0">
					<div class="no-data">未查询到相关数据</div>
				</div>
			</el-card>
		</div>

		<!-- 未查询时的空状态引导 -->
		<div class="empty-section" v-if="!hasSearched && !loading">
			<div class="empty-content">
				<div class="empty-icon-wrap">
					<i class="el-icon-search empty-icon"></i>
				</div>

				<p class="empty-text-search">正版查询验证</p>
				<p class="empty-desc-search">请在上方输入报告编号开始验证查询，系统将展示该报告编号下的企业正版法规标准清单及授权使用说明</p>
			</div>
		</div>
	</div>
</template>

<script>
	import { getConsumerOrderVerify } from '@/api/order/order';
	import { postMemberBookListAddToMyLawLibraryVerify } from '@/api/book/book';

	// ========== 模拟数据 ==========
	const MOCK_DATA = {
		companyName: '量大公司3',
		reportNo: '26061209554045345699',
		generateTime: '2026-06-12 09:55:40',
		rows: [
			{ id: 1, fileNo: 'TSG 01-2014', name: '特种设备安全技术规范制定导则', type: '特种设备安全技术规范 (TSG)', status: '现行' },
			{ id: 2, fileNo: 'TSG 07-2019', name: '特种设备生产和充装单位许可规则', type: '特种设备安全技术规范 (TSG)', status: '现行' },
			{ id: 3, fileNo: 'D0001-2009', name: '压力管道安全技术监察规程—工业管道', type: '特种设备安全技术规范 (TSG)', status: '废止' },
			{ id: 4, fileNo: 'D7005-2018', name: '压力管道定期检验规则—工业管道', type: '特种设备安全技术规范 (TSG)', status: '废止' },
			{ id: 5, fileNo: 'ZC001-2009', name: '锅炉压力容器专用钢板（带）制造许可规则', type: '特种设备安全技术规范 (TSG)', status: '废止' },
			{ id: 6, fileNo: '1886.121-2015', name: '食品安全国家标准 食品添加剂 丁酸', type: '国家标准', status: '现行' },
			{ id: 7, fileNo: '23971-2009', name: '有机热载体', type: '国家标准', status: '现行' },
			{ id: 8, fileNo: '14560-1993', name: '150t以下履带起重机技术条件', type: '国家标准', status: '被代替' },
			{ id: 9, fileNo: '150.1-2024', name: '压力容器 第1部分：通用要求', type: '国家标准', status: '现行' },
			{ id: 10, fileNo: '150.3-2024', name: '压力容器 第3部分：设计', type: '国家标准', status: '现行' },
			{ id: 11, fileNo: '17626.19-2022', name: '电磁兼容 试验和测量技术 第19部分：交流电源端口2kHz~150kHz差模传导骚扰和通信信号抗扰度试验', type: '国家标准', status: '现行' },
			{ id: 12, fileNo: '20801.3-2020', name: '压力管道规范 工业管道 第3部分：设计和计算', type: '国家标准', status: '被代替' },
			{ id: 13, fileNo: '31440-2025', name: '封闭式收费用收发卡机', type: '国家标准', status: '现行' },
			{ id: 14, fileNo: '45805-2025', name: '信控服务机构分类及编码规范', type: '国家标准', status: '现行' },
			{ id: 15, fileNo: '45907-2025', name: '人工智能 服务能力成熟度评估', type: '国家标准', status: '现行' },
			{ id: 16, fileNo: '45917-2025', name: '企业对消费者（B2C）电子商务平台用户条款编制指南', type: '国家标准', status: '现行' },
			{ id: 17, fileNo: '45925-2025', name: '毫米波信号增强玻璃', type: '国家标准', status: '现行' },
			{ id: 18, fileNo: '6104.1-2025', name: '工业车辆 术语 第1部分：工业车辆类型', type: '国家标准', status: '现行' },
			{ id: 19, fileNo: 'DB37 4732-2024', name: '设施蔬菜园区农业机械配置规范', type: '地方标准', status: '现行' },
			{ id: 20, fileNo: 'NB/T 47013', name: '承压设备无损检测 标准释义', type: '图书', status: '现行' }
		]
	};

	export default {
		name: 'Checker',
		data() {
			return {
				searchForm: {
					keyword: ''
				},
				reportInfo: {
					companyName: '',
					reportNo: '',
					generateTime: ''
				},
				tableData: [],
				loading: false,
				hasSearched: false,
				isBV: false
			};
		},
		mounted() {
			this.$nextTick(() => {
				const input = this.$refs.searchInput;
				if (input) {
					input.focus();
				}
			});
		},
		methods: {
			// 查询
			handleSearch() {
				if (!this.searchForm.keyword || !this.searchForm.keyword.trim()) {
					this.$message.warning('请输入报告编号');
					return;
				}
				this.doSearch();
			},

			// 重置
			handleReset() {
				this.searchForm.keyword = '';
				this.tableData = [];
				this.reportInfo = { companyName: '', reportNo: '', generateTime: '' };
				this.hasSearched = false;
				this.isBV = false;
			},

			// 执行查询
			doSearch() {
				const keyword = this.searchForm.keyword.trim();
				this.isBV = /BV/i.test(keyword);
				this.loading = true;

				const apiCall = this.isBV ? postMemberBookListAddToMyLawLibraryVerify(keyword) : getConsumerOrderVerify(keyword);

				apiCall
					.then(res => {
						if (res.code === 200) {
							const { corporateName, verifyCode, createTime, verifyBuyDetailList, verifyBookDetailList } = res.data || {};
							this.reportInfo = {
								companyName: corporateName || '',
								reportNo: verifyCode || '',
								generateTime: createTime || ''
							};
							this.tableData = verifyBuyDetailList || verifyBookDetailList || [];
							this.hasSearched = true;
						} else {
							this.tableData = [];
							this.reportInfo = { companyName: '', reportNo: '', generateTime: '' };
							this.$message.warning(res.msg || '查询失败，请稍后重试');
						}
					})
					.catch(() => {
						this.tableData = [];
						this.reportInfo = { companyName: '', reportNo: '', generateTime: '' };
					})
					.finally(() => {
						this.loading = false;
					});
			}
		}
	};
</script>

<style lang="less" scoped>
	// ========== 绿色横幅 ==========
	.searchbanner {
		// background: linear-gradient(to right, rgb(0, 166, 61), rgb(0, 153, 102));
		background: linear-gradient(135deg, #155dfc, #4f39f6);
		color: #ffffff;
		padding: 28px 0;

		.banner-content {
			width: 78%;
			max-width: 1200px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			justify-content: space-between;
		}

		.banner-title {
			font-size: 20px;
			font-weight: 700;
			margin: 0 0 4px 0;
			line-height: 1.3;
		}

		.banner-subtitle {
			font-size: 13px;
			color: rgba(255, 255, 255, 0.85);
			line-height: 1.5;
			margin: 0;
		}
	}

	// ========== 搜索区域 ==========
	.search-section {
		width: 78%;
		max-width: 1200px;
		// margin: -16px auto 0;
		margin: 24px auto 0;
		position: relative;
		z-index: 2;
	}

	.search-card {
		border-radius: 8px;
		box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);

		/deep/ .el-card__body {
			padding: 20px 24px;
		}
	}

	.search-form {
		/deep/ .el-form-item {
			margin-bottom: 12px;
			width: 100%;
		}

		/deep/ .el-form-item__label {
			font-size: 16px;
			font-weight: 600;
			color: #1e3a5f;
		}
	}

	.search-input-wrap {
		display: flex;
		align-items: center;
		gap: 12px;
		width: 100%;
	}

	.search-input {
		flex: 1;

		/deep/ .el-input__inner {
			border-radius: 6px;
			height: 40px;
		}
	}

	// 按钮组靠右
	.search-input-wrap /deep/ .el-button {
		flex-shrink: 0;
	}

	// ========== 查询结果区域 ==========
	.result-section {
		width: 78%;
		max-width: 1200px;
		margin: 20px auto 40px;
	}

	.result-card {
		border-radius: 8px;
		box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);

		/deep/ .el-card__body {
			padding: 40px 48px;
		}
	}

	// ========== 报告标题 ==========
	.report-title-wrap {
		text-align: center;
		margin-bottom: 24px;
	}

	.report-main-title {
		font-size: 22px;
		font-weight: 700;
		color: #1e293b;
		margin: 0;
		// letter-spacing: 2px;
	}

	.report-subtitle {
		font-size: 21px;
		font-weight: 600;
		color: #1e293b;
		text-align: center;
		margin-top: 0;
	}

	// ========== 企业信息行 ==========
	.report-info-bar {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		padding: 12px 0;
		border-bottom: 1px solid #e5e7eb;
		margin-bottom: 24px;
		gap: 8px 24px;

		.info-left {
			display: flex;
			align-items: center;
		}

		.info-right {
			display: flex;
			align-items: center;
			margin-left: auto;
		}

		.info-label {
			font-size: 13px;
			color: #6b7280;
		}

		.info-value {
			font-size: 14px;
			color: #1e293b;
			font-weight: 600;
		}

		.info-count {
			font-size: 14px;
			// color: #16a34a;
			font-weight: 700;
		}
	}

	// ========== 节标题 ==========
	.section-block {
		margin-bottom: 32px;
	}

	.section-title {
		font-size: 15px;
		font-weight: 600;
		color: #1e293b;
		margin: 0 0 12px 0;
		padding-left: 8px;
		border-left: 3px solid #2563eb;
	}

	// ========== 验真表格 ==========
	.verify-table-wrap {
		overflow-x: auto;
	}

	.verify-table {
		width: 100%;
		border-collapse: collapse;
		font-size: 13px;
		color: #374151;

		th {
			background: #f1f5f9;
			font-weight: 600;
			color: #475569;
			text-align: center;
			padding: 10px 8px;
			border: 1px solid #e5e7eb;
			white-space: nowrap;
		}

		td {
			padding: 8px;
			border: 1px solid #e5e7eb;
			vertical-align: middle;
		}

		.col-seq {
			width: 60px;
			text-align: center;
		}

		.col-code {
			width: 150px;
			text-align: center;
			font-family: 'SF Mono', 'Consolas', 'Monaco', 'Courier New', monospace;
			font-size: 12px;
		}

		.col-name {
			min-width: 200px;
			text-align: left;
			line-height: 1.5;
		}

		.col-type {
			width: 160px;
			text-align: center;
		}

		.col-status {
			width: 80px;
			text-align: center;
		}

		.row-even {
			background: #fafbfc;
		}

		tbody tr:hover {
			background: #f5f7fa;
		}
	}

	// ========== 使用说明 ==========
	.usage-statement {
		margin-bottom: 20px;
		padding: 16px 20px;
		background: #fafbfc;
		border-radius: 6px;
		border: 1px solid #f1f5f9;
	}

	.usage-paragraph {
		font-size: 13px;
		color: #475569;
		line-height: 1.9;
		margin: 0 0 12px 0;
		text-indent: 2em;

		&:last-child {
			margin-bottom: 0;
		}

		strong {
			color: #1e293b;
		}

		a {
			// color: #16a34a;
			text-decoration: none;

			&:hover {
				text-decoration: underline;
			}
		}
	}

	// ========== 无数据 ==========
	.no-data {
		text-align: center;
		padding: 40px 0;
		font-size: 14px;
		color: #94a3b8;
	}

	// ========== 空状态引导 ==========
	.empty-section {
		width: 100%;
		max-width: 1200px;
		margin: 40px auto 80px;
		display: flex;
		justify-content: center;
	}

	.empty-content {
		text-align: center;
		padding: 100px 40px;
		background: #fff;
		border-radius: 12px;
		box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
		width: 100%;
	}

	.empty-icon-wrap {
		width: 100px;
		height: 100px;
		background: rgba(37, 99, 235, 0.12);
		border-radius: 50%;
		margin-bottom: 16px;
		margin: 0 auto 16px auto;
		display: flex;
		align-items: center;
		justify-content: center;
		.empty-icon {
			font-size: 42px;
			color: #2563eb;
		}
	}

	.empty-text-search {
		font-size: 16px;
		color: #1e293b;
		margin: 0 0 8px 0;
		font-weight: 500;
	}

	.empty-desc-search {
		font-size: 14px;
		color: #94a3b8;
		margin: 0;
		max-width: 380px;
		line-height: 1.7;
		margin: 12px auto 0;
	}

	// ========== 响应式 ==========
	@media screen and (min-width: 2100px) {
		.empty-content {
			padding: 140px 40px;
		}
	}

	@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
		.searchbanner .banner-content,
		.search-section,
		.result-section,
		.empty-section {
			width: 94%;
		}
	}

	@media screen and (max-width: 767px) {
		.searchbanner .banner-content,
		.search-section,
		.result-section,
		.empty-section {
			width: 94%;
		}

		.search-input {
			width: 240px;
		}

		.result-card /deep/ .el-card__body {
			padding: 16px;
		}
	}
</style>
